import * as ReactDOMClient from 'react-dom/client';
import * as Sentry from '@sentry/react';

import 'config/sentry';
import { MainApp } from 'main/App';

const entrypointElement = document.getElementById('app_entrypoint');

if (!entrypointElement) throw new Error('Root element not found');

const root = ReactDOMClient.createRoot(entrypointElement, { onRecoverableError: Sentry.reactErrorHandler() });

root.render(<MainApp />);
